<template>
  <SearchPage
    pageName="Disbursements"
    :searchBoxPlaceholderText="`Search by CLUID, First name, Last name, App ID`"
  />
</template>

<script setup lang="ts">
import { onMounted, ref, onBeforeMount, onUnmounted } from "vue";
import SearchPage from "@/components/v2/search-page/SearchPage.vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";

const loading = ref<boolean>(false);
const searchPageStore = useSearchPageStore();

/////////////////////////////////////////////////////////////////
// vue onMounted - executes when the page is finished mounting //
/////////////////////////////////////////////////////////////////
onBeforeMount(async () => {
  await searchPageStore.getFilters("disbursement");
  await searchPageStore.getDisbursements();
});

onMounted(async () => {
  loading.value = false;
});

onUnmounted(() => {
  searchPageStore.$reset();
});
</script>
